import script from "./AdminAnalytics.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAnalytics.vue?vue&type=script&setup=true&lang=js"

import "./AdminAnalytics.vue?vue&type=style&index=0&id=6b625051&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b625051"]])

export default __exports__